import { Observable, Subscription } from 'rxjs';
import { SkyDialogWithAttachmentsAndOptionsUploadingEvent } from '../interfaces';

export abstract class SkyDialogWithAttachmentsAndOptionsApiProvider {
  abstract uploadFile(file: File | null, uploadInitiator?: string): Observable<{ id: number; file: string } | null>;

  abstract onUploading(cb: (uploadingEvent: SkyDialogWithAttachmentsAndOptionsUploadingEvent) => unknown): Subscription;
}
